module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-7-faacc5fbe54ccdd4f7a12f6fbe25d809.jpg";